import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "rsuite";
import { trackHeapEvent } from "@hoteltradergit/ht-telemetry-ui-lib";
import {
  WaveImage,
  LetteringTop,
  LetteringBottom,
  CloseIcon,
  ChevronRightIcon,
} from "./blackFridayAssets";
import {
  BLACK_FRIDAY_COPY,
  BLACK_FRIDAY_HEAP,
} from "../../constants/blackFriday";
import "./BlackFridayModal.scss";

/**
 * Home-page pop-up for the Black Friday offer (EO-1892; copy from the Notion
 * spec). The caller decides when it opens (once per session, or on arrival
 * from the email link); this only renders it.
 */
const BlackFridayModal = ({ open, card, onReview, onClose }) => {
  const recommendationId = card?.recommendationId;

  useEffect(() => {
    if (open && recommendationId) {
      trackHeapEvent(BLACK_FRIDAY_HEAP.modalShown, {
        recommendation_id: recommendationId,
      });
    }
  }, [open, recommendationId]);

  if (!card) return null;

  const handleClose = () => {
    trackHeapEvent(BLACK_FRIDAY_HEAP.modalDismissed, {
      recommendation_id: recommendationId,
    });
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="bf-modal"
      dialogClassName="bf-modal__dialog"
      backdropClassName="bf-modal-backdrop"
    >
      <div className="bf-modal__panel">
        <img src={WaveImage} alt="" className="bf-modal__wave" />
        <img src={LetteringTop} alt="" className="bf-modal__lettering-top" />
        <img
          src={LetteringBottom}
          alt=""
          className="bf-modal__lettering-bottom"
        />

        <div className="bf-modal__content">
          <div className="bf-modal__copy">
            <h2 className="bf-modal__title">
              <span className="bf-modal__accent bf-modal__title-line">
                {BLACK_FRIDAY_COPY.modalTitleAccent}
              </span>{" "}
              <span className="bf-modal__title-line">
                {BLACK_FRIDAY_COPY.modalTitleTail}
              </span>
            </h2>
            <div className="bf-modal__body">
              <p>
                {`${BLACK_FRIDAY_COPY.modalBody} `}
                <span className="bf-modal__highlight">
                  {BLACK_FRIDAY_COPY.modalBodyAccent}
                </span>
              </p>
            </div>
          </div>
          <button
            type="button"
            className="bf-modal__cta"
            onClick={onReview}
            data-heap-id={BLACK_FRIDAY_HEAP.modalReviewId}
          >
            {BLACK_FRIDAY_COPY.modalCta}
            <img src={ChevronRightIcon} alt="" className="bf-modal__cta-icon" />
          </button>
        </div>

        <button
          type="button"
          className="bf-modal__close"
          onClick={handleClose}
          aria-label={BLACK_FRIDAY_COPY.close}
          data-heap-id={BLACK_FRIDAY_HEAP.modalCloseId}
        >
          <CloseIcon aria-hidden="true" className="bf-modal__close-icon" />
        </button>
      </div>
    </Modal>
  );
};

BlackFridayModal.propTypes = {
  open: PropTypes.bool,
  card: PropTypes.shape({
    recommendationId: PropTypes.string,
    promoObjectDr: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  onReview: PropTypes.func,
  onClose: PropTypes.func,
};

export default BlackFridayModal;
